import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import './BottomNav.css';

/**
 * Mobile-only bottom navigation bar. Primary destinations get one tap; the
 * "More" button opens the bottom sheet for the long tail. Hidden on desktop.
 */
const BottomNav = ({ onMore }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const showTCG = user?.gamePreferences ? user.gamePreferences.tcg === true : true;
  const showVGC = user?.gamePreferences ? user.gamePreferences.vgc === true : true;
  const vgcOnly = showVGC && !showTCG;

  const decksPath = vgcOnly ? '/lists-vgc' : '/lists';
  const analyticsPath = vgcOnly ? '/analytics/vgc/matches' : '/analytics/tcg/matches';

  const path = location.pathname;
  const isActive = (matchers) => matchers.some((m) => path === m || path.startsWith(m));

  const items = [
    { to: '/dashboard', logo: true, label: 'Home', match: ['/dashboard', '/'] },
    { to: decksPath, icon: 'fa-layer-group', label: 'Lists', match: ['/lists', '/decks', '/teams'] },
    { to: analyticsPath, icon: 'fa-chart-line', label: 'Stats', match: ['/analytics'] },
    { to: '/tournament/analytics', icon: 'fa-trophy', label: 'Tourneys', match: ['/tournament'] },
  ];

  return (
    <nav className="bottom-nav" aria-label="Primary">
      {items.map((item) => {
        const active = isActive(item.match);
        return (
          <Link
            key={item.label}
            to={item.to}
            className={`bottom-nav__item ${active ? 'is-active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            {item.logo
              ? <img className="bottom-nav__logo" src="/logo.png" alt="" aria-hidden="true" />
              : <i className={`fas ${item.icon}`} aria-hidden="true" />}
            <span className="bottom-nav__label">{item.label}</span>
          </Link>
        );
      })}
      <button
        type="button"
        className="bottom-nav__item bottom-nav__more"
        onClick={onMore}
        aria-label="Open menu"
      >
        <i className="fas fa-bars" aria-hidden="true" />
        <span className="bottom-nav__label">More</span>
      </button>
    </nav>
  );
};

export default React.memo(BottomNav);
